var _path;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgConnectedResearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m20.287 0.29883v3.0723c0 4.358 0.837 7.8479-2.125 12.129-0.044081 0.063802-0.16015 0.19701-0.29297 0.34961-2.2122-1.3614-5.8132-3.0078-10.551-3.0078h-6.5723c-0.27838 0.93124-0.48054 1.8946-0.60156 2.8828h7.1895c3.374 0 6.0865 0.57028 8.1895 1.8633 0.22473 0.1383 0.43956 0.27982 0.64844 0.42383-1.5158 2.1951-3.3301 5.7243-3.3301 10.354v6.5176c0.94067 0.27551 1.9139 0.47563 2.9121 0.5957v-7.1309c0-3.337 1.0963-6.0196 2.4043-8.0996 0.095473-0.15198 0.19456-0.29688 0.29297-0.44141 0.3612 0.30348 0.709 0.59423 1.041 0.83984 3.843 2.84 8.6858 2.1895 13.09 2.1895h2.5703c0.27342-0.93051 0.47135-1.8921 0.58789-2.8789h-3.1582c-4.404 0-7.9328 0.56672-12.26-2.3633-0.013876-0.009379-0.058087-0.045263-0.076172-0.058594 0.36484-0.42411 0.71289-0.83017 1.002-1.2129 2.87-3.8 1.9512-8.5932 1.9512-12.951v-2.4512c-0.93979-0.28499-1.9136-0.49173-2.9121-0.62109z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectedResearch);
export default __webpack_public_path__ + "static/media/connected_research.c33ef34e6e8d619db0e1ded936abfcbe.svg";
export { ForwardRef as ReactComponent };